const linkOptions = [
  { label: 'Open link in same tab', value: '_self', default: true },
  { label: 'Open link in new tab', value: '_blank' },
];

export const DEFAULT_TARGET = linkOptions.find(opt => opt.default).value;

export default linkOptions;
